var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[(_vm.terms)?_c('div',{staticClass:"text-center mt-3"},[(_vm.terms.description)?_c('div',{staticClass:"lead my-4",domProps:{"innerHTML":_vm._s(_vm.terms.description)}}):_vm._e()]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }